import { call, put, select, takeLatest } from 'redux-saga/effects'
import { handleApiError } from '../../../components/apiErrorHandler/store/apiErrorHandler.actions'
import { getAuthenticationJwtSelector } from '../../login/selectors/getAuthenticationJwt.selector'
import { EKGImportConstants } from '../store/ekgImport.constants'
import { EKGImportService } from '../services/ekgImport.service'
import { IFetchEventsAndReportsRequest, IFetchEventsAndReportsResponse } from '../store/ekgImport.types'
import { setEventsListResults, setReportsListResults } from '../store/ekgImport.actions'
import { getEKGImportSelector } from '../selectors'

export function* getEventsAndReportsResults() {
  const authenticationJwt: string = yield select(getAuthenticationJwtSelector)
  const { selectedPowerOnTime, loadedEvents, eventsList } = yield select(getEKGImportSelector)

  if (loadedEvents) {
    yield put(setEventsListResults(eventsList))
    return
  }

  try {
    const ekgImportService = new EKGImportService(authenticationJwt as string)
    const fetchEventsAndReportsRequest: IFetchEventsAndReportsRequest = {
      powerOnTimeId: selectedPowerOnTime.id,
    }

    const response: IFetchEventsAndReportsResponse = yield call(
      [ekgImportService, ekgImportService.fetchEventsAndReports],
      fetchEventsAndReportsRequest
    )
    if (response.status === 200) {
      if (response.data.events) {
        const eventsList = response.data.events

        yield put(setEventsListResults(eventsList))
      }
      if (response.data.reports) {
        const reportsList = response.data.reports

        const filteredReportsList = reportsList
          .filter((report) => {
            return !!report.description
          })
          .map((report) => {
            return {
              ...report,
              image: null,
            }
          })

        yield put(setReportsListResults(filteredReportsList))
      }
    } else {
      response.failure = true
      if (response.messages?.length) {
        const index = response.messages.findIndex((x) => x.status === response.status)
        response.responseMessage = response.messages[index].message
      } else {
        response.responseMessage =
          'There was an error processing your EKG import. Please contact customer support for further assistance.'
      }
      yield put(handleApiError(response))
    }
  } catch (e: any) {
    const cause = e.message ? e.message : 'unknown'
    const errorResponse = {
      status: null,
      messages: [
        {
          status: null,
          display: [
            { id: 3, name: 'Alert' },
            { id: 1, name: 'Log' },
          ],
          message: `An error occurred during EKG import. Cause: ${cause}`,
        },
      ],
    }
    yield put(handleApiError(errorResponse))
  }
}

export function* getEventsAndReportsResultsSaga() {
  yield takeLatest([EKGImportConstants.GET_EVENTS_AND_REPORTS_RESULTS], getEventsAndReportsResults)
}
